export default __webpack_public_path__ + "static/media/blog-img224.5bdece43.jpg";